module.exports = __webpack_public_path__ + "img/no.d3404428.png";